import React, { useContext } from "react";
import PropTypes from "prop-types";
import * as S from "components/common/Input/style";
import Text from "components/common/Text";
import { SIZE } from "constant";
import { ThemeContext } from "helpers/contexts";

ErrorMsg.propTypes = {
  errorMsg: PropTypes.string,
};

function ErrorMsg(props) {
  const theme = useContext(ThemeContext);
  return (
    <S.ErrorMsgContainer>
      <Text size={SIZE.xxs} color={theme.colors.red.salmon}>
        {props.errorMsg}
      </Text>
    </S.ErrorMsgContainer>
  );
}

export default ErrorMsg;
